<ul class="x-navigation sidebar-margin leftsidenavul" *ngIf="isVisitsInMobileView()">
  <!-- Loop through nav structure -->
  <li *ngFor="let menu of navStructure; let i = index" class="leftnavmainitems" [ngClass]="{ 'xn-openable': menu.type == 'menu'}" [class.active]="i == 0">
    <a class="navChilditem" id="menu.name" (click)="menu.type == 'feature' ? menuNavigation(menu) : null">
      <span>
        <img [src]="'assets/images/New_Icons/' + menu.icon" alt="'menu.name' + Icon" alt="Nav icon"/>
      </span>
      <span class="xn-text">{{ menu.name }}</span>
    </a>
    <!-- Submenus or features directly inside main menu -->
    <ul class="innerullist" *ngIf="menu.type == 'menu'">
      <li *ngFor="let child of menu.children" [ngClass]="{ 'xn-openable': child.type == 'submenu'}" style="cursor: pointer;">
        <a class="adminpanelullia" (click)="child.type == 'feature' ? menuNavigation(child) : null">
          <span *ngIf="child.icon">
            <img [src]="'assets/images/New_Icons/' + child.icon" alt="'child.name' + Icon" alt="Nav icon"/>
          </span>
          <span class="xn-text leftnavicon">{{ child.name }}</span>
        </a>
        <!--features inside sub menus-->
        <ul class="adminpanelulliaul" *ngIf="child.type == 'submenu'">
          <li *ngFor="let feature of child.children" class="nav-item">
            <a class="navChilditem" (click)="menuNavigation(feature)">
              <span class="xn-text">{{ feature.name }}</span>
            </a>            
          </li>
        </ul>
      </li>
    </ul>
  </li>
</ul>
